

export function getNewDocumentTitle(title: string) {
    return document.title.replace(/.*(- .*)/, `${title} $1`);
}
